import http from "../../http-common";

const sendPrint = (data) => {
    return http.post("/Print/SendPrint", data);
};

const sendPrintStockLocation = (data) => {
    return http.post("/Print/SendPrintStockLocation", data);
};

const getByCodeProduct = (data) => http.post("/ReceiptProduct/GetByCodeProduct", data);

const getByBarCode = (data) => http.post("/ReceiptProduct/GetByBarCode", data);

const getByProductName = (data) => http.post("/ReceiptProduct/GetByProductName", data);

const cancelPrint = (data) => http.post("/Print/CancelPrint", data);

const filterPrint = (data) => http.post("/Print/FilterPrint", data);


export default {
    sendPrint, sendPrintStockLocation, getByCodeProduct, getByBarCode, getByProductName, cancelPrint, filterPrint
};
